import React from "react";
import "../../../styles/Categories.css";
import { Link } from "react-router-dom";

const DietItem = ({
  imageUrl,
  title,
  altText = "Card image",
  onClick,
  linkTo,
}) => {
  return (
    <Link to={linkTo} onClick={onClick}>
      <div className="dietCard">
        <div>
              {title && <h3 className="catCard-title">{title}</h3>}
            </div>
        {imageUrl && (
          <div className="dietCard-image">
            <img src={imageUrl} alt={altText} />
          </div>
        )}
      </div>
    </Link>
  );
};

export default DietItem;
